import { render } from "./CambiarDelegadosPage.vue?vue&type=template&id=02fc9dc7&scoped=true"
import script from "./CambiarDelegadosPage.vue?vue&type=script&lang=js"
export * from "./CambiarDelegadosPage.vue?vue&type=script&lang=js"

import "./CambiarDelegadosPage.vue?vue&type=style&index=0&id=02fc9dc7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fc9dc7"]])

export default __exports__